webpackJsonp([22],{

/***/ 567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(18);

var _reactStatic = __webpack_require__(12);

var _showdown = __webpack_require__(71);

var _showdown2 = _interopRequireDefault(_showdown);

var _storyblokReact = __webpack_require__(31);

var _storyblokReact2 = _interopRequireDefault(_storyblokReact);

__webpack_require__(567);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var converter = new _showdown2.default.Converter();

var colors = ['overlay--red', 'overlay--yellow', 'overlay--green', 'overlay--black'];
var isBrowser = typeof window !== 'undefined';
var Join = function Join(props) {
  var content = props.story.content;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        'title',
        null,
        content && content.top[0].title
      )
    ),
    content && content.top.map(function (el) {
      return _react2.default.createElement(
        _storyblokReact2.default,
        { key: el._uid, content: el },
        _react2.default.createElement(
          'div',
          {
            className: 'hero hero--small',
            style: {
              backgroundImage: 'url(' + el.image + ')',
              backgroundPosition: 'center ' + (el.image_offset ? el.image_offset + '%' : '50%')
            }
          },
          _react2.default.createElement('div', { className: 'hero__overlay' }),
          _react2.default.createElement(
            'div',
            { className: 'wrapper' },
            _react2.default.createElement(
              'h1',
              { className: 'hero__title hero--small__title' },
              el.title
            )
          )
        )
      );
    }),
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'join__intro' },
        content.title_section.map(function (el) {
          return _react2.default.createElement(
            _storyblokReact2.default,
            { key: el._uid, content: el },
            el.component === 'Section Title' && _react2.default.createElement(
              'h2',
              { className: 'bold' },
              el.text
            ),
            el.component === 'Rich Text' && _react2.default.createElement('div', {
              className: 'paragraph--lead',
              dangerouslySetInnerHTML: {
                __html: converter.makeHtml(el.markdown)
              }
            }),
            el.component !== 'Rich Text' && el.component !== 'Section Title' && _react2.default.createElement(
              'p',
              { className: 'paragraph--lead' },
              el.text
            )
          );
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'wrapper wrapper--flex overlay__wrapper' },
      content.steps.map(function (el, i) {
        return _react2.default.createElement(
          _storyblokReact2.default,
          { content: el, key: el._uid + '-nav-item' },
          _react2.default.createElement(
            'div',
            { className: 'overlay__container' },
            _react2.default.createElement(
              'a',
              { href: '#section-' + i },
              _react2.default.createElement(
                'div',
                { className: 'overlay__content' },
                _react2.default.createElement(
                  'h2',
                  null,
                  el.nav_text
                )
              ),
              _react2.default.createElement('i', { className: 'icon-arrow-circle' }),
              _react2.default.createElement('div', { style: { backgroundImage: 'url(' + el.nav_image + ')' }, alt: '', className: 'join__image' }),
              _react2.default.createElement('div', { className: 'overlay ' + colors[i % 4] })
            )
          )
        );
      })
    ),
    content.steps.map(function (el, i) {
      return _react2.default.createElement(
        _storyblokReact2.default,
        { key: el._uid, content: el },
        _react2.default.createElement(
          'div',
          { className: 'wrapper ' },
          _react2.default.createElement(
            'div',
            { className: 'join-section', id: 'section-' + i },
            _react2.default.createElement(
              'div',
              { className: 'col-1-2' },
              _react2.default.createElement(
                'div',
                { className: 'join-section__title' },
                el.title
              ),
              _react2.default.createElement(
                'div',
                { style: { padding: '0 2rem 0 0' } },
                _react2.default.createElement('div', {
                  className: 'rich-text',
                  dangerouslySetInnerHTML: {
                    __html: converter.makeHtml(el.lead)
                  }
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-1-2 join-section__col' },
              _react2.default.createElement('div', {
                className: 'rich-text',
                dangerouslySetInnerHTML: {
                  __html: converter.makeHtml(el.info)
                }
              })
            )
          )
        )
      );
    }),
    _react2.default.createElement(
      'div',
      { className: 'join__banner-wrapper' },
      content.banner.map(function (el) {
        return _react2.default.createElement(
          _storyblokReact2.default,
          { key: el._uid, content: el },
          _react2.default.createElement(
            'div',
            { className: 'col-1-2' },
            _react2.default.createElement(
              'div',
              { className: 'content' },
              _react2.default.createElement(
                'h2',
                { className: 'heading--big bold' },
                isBrowser ? sessionStorage.getItem('form') ? content.form[0].thank_you_title : el.heading : ''
              ),
              _react2.default.createElement(
                'p',
                { className: 'paragraph--sans' },
                isBrowser ? sessionStorage.getItem('form') ? content.form[0].thank_you_text : el.subheading : ''
              )
            )
          ),
          _react2.default.createElement('div', { className: 'join__banner--image', style: { backgroundImage: 'url(' + el.image + ')' } })
        );
      }),
      _react2.default.createElement(
        'div',
        { className: 'col-1-2 form__col', id: 'form-column' },
        _react2.default.createElement(
          _storyblokReact2.default,
          { content: content.form[0] },
          _react2.default.createElement(
            'form',
            {
              className: 'join__form',
              method: 'post',
              name: 'join-us-form',
              id: 'join-us-form',
              action: 'https://penguin-utility-server.herokuapp.com/form/user/povertystoplight?redirect=' + (isBrowser ? window.location.href + '#form-column' : ''),
              onSubmit: function onSubmit() {
                return isBrowser ? sessionStorage.setItem('form', 'setForm') : '';
              }
            },
            _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'Poverty Stoplight Form' }),
            _react2.default.createElement('input', {
              className: 'join__form--input',
              type: 'text',
              placeholder: content.form[0].name_label || 'Name',
              name: 'Name',
              required: true
            }),
            _react2.default.createElement('input', {
              className: 'join__form--input',
              type: 'text',
              placeholder: content.form[0].phone_label || 'Phone',
              name: 'Phone'
            }),
            _react2.default.createElement('input', {
              className: 'join__form--input',
              type: 'email',
              placeholder: content.form[0].email_label || 'E-mail*',
              name: 'E-mail',
              required: true
            }),
            _react2.default.createElement('textarea', {
              className: 'join__form--message',
              form: 'join-us-form',
              type: 'text',
              placeholder: content.form[0].message_label || 'Message',
              name: 'Message',
              required: true
            }),
            _react2.default.createElement(
              'button',
              { role: 'none', className: 'button button--red join__form--submit', type: 'submit' },
              content.form[0].send_label || 'SEND'
            )
          )
        )
      )
    )
  );
};

exports.default = (0, _reactStatic.withRouteData)(Join);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Join.c7ea1265.js